import { FclRoute } from "./route-fcl.model";
import { LclRoute } from "./route-lcl.model";
import { Route } from "./route-type";
import { containerLoad } from "../shared/container/load-types.const";
import { TierMapper } from "../tier/tier.mapper";
import { ContainerPrices } from "../shared/container/container-prices.model";
import { AirRoute } from "./route-air.model";
import { rateDiscriminator } from "../rate/rate-discriminator.const";
import { LtlRoute } from "./route-ltl.model";
import { AirTariffRoute } from "./route-airtariff.model";
import { FtlRoute } from "./route-ftl.model";
import { PtlRoute } from "./route-ptl.model";

export class RouteMapper {
  public static map(data: any): Route {
    if (!data) {
      return;
    }

    if (!data.discriminator) {
      console.trace("no discriminator");
    }

    if (
      data.discriminator === containerLoad.fcl ||
      data.discriminator === rateDiscriminator.fclFlat
    ) {
      return new FclRoute(
        data.id,
        data.discriminator,
        data.comment,
        TierMapper.map(data.tier),
        new ContainerPrices(data.containers),
      );
    }

    if (
      data.discriminator === containerLoad.lcl ||
      data.discriminator === rateDiscriminator.lclFlat
    ) {
      return new LclRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.chargeableWeightPrice,
        data.blPrice,
      );
    }

    if (
      data.discriminator === containerLoad.air ||
      data.discriminator === rateDiscriminator.airFlat
    ) {
      return new AirRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.chargeableWeightPrice,
        data.blPrice,
      );
    }

    if (
      data.discriminator === "airtariff" ||
      data.discriminator === "airtariff-flat"
    ) {
      return new AirTariffRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.weightPriceLt45,
        data.weightPriceGt45,
        data.weightPriceGt100,
        data.weightPriceGt300,
        data.weightPriceGt500,
        data.weightPriceGt1000,
      );
    }

    if (
      data.discriminator === containerLoad.ltl ||
      data.discriminator === rateDiscriminator.ltlFlat ||
      data.discriminator === rateDiscriminator.ltlLinked
    ) {
      return new LtlRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.chargeableWeightPrice,
      );
    }

    if (
      data.discriminator === rateDiscriminator.ftl ||
      data.discriminator === rateDiscriminator.ftlFlat
    ) {
      return new FtlRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.blPrice,
      );
    }

    if (
      data.discriminator === rateDiscriminator.ptl ||
      data.discriminator === rateDiscriminator.ptlFlat
    ) {
      return new PtlRoute(
        data.id,
        data.discriminator,
        data.comment,
        data.chargeableWeightPrice,
        data.blPrice,
      );
    }
  }
}
